module.exports = __webpack_public_path__ + "static/media/YB5F18_3.8963a6d4.jpg";